<template>
  <div class="person">
    <!-- personal data -->
    <section>
      <el-row>
        <el-col :span="24">
          <el-form
            :model="personData"
            :rules="rules"
            ref="personData"
            :label-width="this.$i18n.locale=='en'?'230px':'120px'"
          >
            <el-form-item :label="$t('selfdata.name')">
              <el-input class="inpt" v-model="personData.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('selfdata.people')">
              <el-input class="inpt" v-model="personData.people"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('selfdata.phone')"
              prop="phone"
            >
              <el-input class="inpt" v-model="personData.phone"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('selfdata.telphone')"
              prop="telphone"
            >
              <el-input class="inpt" v-model="personData.telphone"></el-input>
            </el-form-item>
            <el-form-item :label="$t('selfdata.address')">
              <el-input
                v-model="personData.address"
                class="inpt"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('selfdata.des')">
              <el-input
                v-model="personData.des"
                type="textarea"
                resize="none"
                class="textarea"
                :rows="4"
                maxlength="100"
                :placeholder="$t('selfdata.num')"
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button
                :class= "this.$i18n.locale=='en'?'selfwidths':'selfwidth'"
                type="success"
                @click="submit"
              >{{$t('selfdata.save')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<script>
export default {
  name: "personal",
  data() {
    var phonevalid = (rule, value, callback) => {
      var rest = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!rest.test(value) || value == 0) {
        return callback(new Error(this.$t('checkvalid.phone')));
      } else {
        callback();
      }
    };
    return {
      backupName: null, //企业名称称的备份
      personData: {
        people: "",
        name: "",
        phone: "",
        telphone: "",
        address: "",
        des: ""
      },
      rules: {
        phone: [{ validator: phonevalid, trigger: "blur" }],
        telphone: [{ validator: phonevalid, trigger: "blur" }]
      }
    };
  },
  created() {
    this.userInfo();
  },
  methods: {
    userInfo() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/user/get_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              this.personData.name = res.data.data.company_name;
              this.personData.people = res.data.data.company_contact;
              this.personData.phone = res.data.data.company_contact_phone;
              this.personData.telphone = res.data.data.company_phone;
              this.personData.address = res.data.data.company_address;
              this.personData.des = res.data.data.note;
              this.backupName = res.data.data;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 修改公司名
    submit() {
      const data = {
        token: this.$store.state.token,
        company_name: this.personData.name,
        company_contact: this.personData.people,
        company_contact_phone: this.personData.phone,
        company_phone: this.personData.telphone,
        company_address: this.personData.address,
        note: this.personData.des
      };
      this.$http
        .post("/user/edit_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.edit'),
                type: "success",
                duration: 1500
              });
              this.userInfo();
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.person {
  width: 800px;
  padding: 30px 0;
  .el-form-item__content {
    float: left;
    margin-left: 0 !important;
  }
  .el-form-item__label {
    margin-left: 80px;
  }
  .el-form-item__label {
    padding-right: 20px;
  }
  .el-input__inner {
    border: 1px solid #1d5a33;
  }
  .spn {
    cursor: pointer;
    display: inline-block;
    color: #1d5a33;
    margin-left: 5px;
    width: 80px;
    display: inline-block;
    text-align: left;
  }
  .el-button {
    width: auto !important;
  }
  .ipts {
    width: 150px;
  }
  .textarea {
    width: 350px;
  }
  .inpt {
    width: 350px;
    .el-input__inner {
      width: 350px;
    }
  }
  .selfwidth.el-button {
    width: 214px !important;
    margin-left: 200px;
  }
  .selfwidths.el-button {
    width: 214px !important;
    margin-left: 310px;
  }
  .el-button {
    width: auto !important;
    height: 40px !important;
    line-height: 1;
  }
}
</style>
